import React from 'react';
import { Card, Divider, Typography } from '@mui/material';
import ChannelStatisticsSkeleton from './ChannelStatisticsSkeleton';
import { useApi } from 'hooks';

interface ChannelStatisticsProps {
    channelId: string;
}

const ChannelStatistics: React.FC<ChannelStatisticsProps> = (props) => {
    const { api } = useApi();
    const { isLoading, isError, data } = api.useQuery(
        'get',
        '/channel/stats/{channelId}',
        {
            params: {
                path: {
                    channelId: props.channelId,
                },
            },
        },
        {
            refetchInterval: Infinity,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        },
    );
    return (
        <ChannelStatisticsSkeleton isLoading={isLoading} isError={isError}>
            <Card sx={{ maxWidth: 365 }}>
                <Typography variant="h5" gutterBottom component="u">
                    Channel Statistics
                </Typography>
                <Divider sx={{ opacity: 0.6 }} />
                <Typography variant="body1" gutterBottom component="div">
                    Uploaded Videos:{data?.videos}
                </Typography>
                <Typography variant="body1" gutterBottom component="div">
                    Channel Views:{data?.views}
                </Typography>
                <Typography variant="body1" gutterBottom component="div">
                    Subscribers:{data?.subscribers}
                </Typography>
            </Card>
        </ChannelStatisticsSkeleton>
    );
};

export default ChannelStatistics;
